const dateISOTimezone = (date: Date) => {
  const tzoffset = (new Date()).getTimezoneOffset() * 60000;
  return (new Date(date.getTime() - tzoffset)).toISOString().slice(0, -1);
};

export default dateISOTimezone;
